import React, { useState, useRef, useEffect } from "react";
// import Logo from "../assets/logo.png";
import "./swiper.css";


export default function Slider() {
    const [currentSlide, setCurrentSlide] = useState(0);

    const videoRef = useRef(null);

    const slides = [
        {
            type: "video",
            src: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v7_yshrnw.mp4",
            poster: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v7_yshrnw.jpg"
        },
        {
            type: "video",
            src: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v5sora_ycbodi.mp4",
            poster: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v5sora_ycbodi.jpg"
        },
        {
            type: "video",
            src: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v6_pdmfv4.mp4",
            poster: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v6_pdmfv4.jpg"
        },
        {
            type: "video",
            src: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v4sora_coief5.mp4",
            poster: "https://res.cloudinary.com/djdgvpeez/video/upload/f_auto,q_auto/v4sora_coief5.jpg"
        }
    ];

    const slide = slides[currentSlide];

    // Ensure video plays and reloads when switching slides
    useEffect(() => {
        if (slide.type === "video" && videoRef.current) {
            videoRef.current.load();
            videoRef.current.play().catch(() => { });
        }
    }, [currentSlide, slide.src]);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    // Auto-play slides
    useEffect(() => {
        const timer = setInterval(() => {
            nextSlide();
        }, 8000); // Change slide every 8 seconds
        return () => clearInterval(timer);
    }, [currentSlide]);


    return (
        <div className="slider-wrapper">
            <div className="slide-inner">
                {slide.type === "video" ? (
                    <video
                        key={slide.src}
                        ref={videoRef}
                        src={slide.src}
                        poster={slide.poster}
                        className="slide-image slide-video fade-in"
                        autoPlay
                        muted
                        loop
                        playsInline
                        preload={currentSlide === 0 ? "auto" : "metadata"}
                        fetchpriority={currentSlide === 0 ? "high" : "low"}
                    />
                ) : (
                    <img 
                        key={slide.src} 
                        src={slide.src} 
                        alt="Slide" 
                        className="slide-image fade-in" 
                        width="1920" 
                        height="1080"
                    />
                )}
                <div className="slide-overlay"></div>

                <div className="slide-center animate-content" key={currentSlide}>
                    {/* <img src={Logo} alt="logo" className="logo-large" /> */}
                    {/* <h1 className="company-name">TRIO THOUGHT</h1>
          <h2 className="company-subtitle">SOLUTIONS</h2> */}
                    {/* <p className="motto-subtitle">OUR MOTTO</p> */}
                    <h1 className="motto-title">
                        Think, Transform & Thrive
                    </h1>

                </div>
            </div>

            <button onClick={prevSlide} className="nav-button nav-prev">
                &#10094;
            </button>
            <button onClick={nextSlide} className="nav-button nav-next">
                &#10095;
            </button>

            <div className="pagination">
                {slides.map((_, i) => (
                    <button
                        key={i}
                        className={`dot ${i === currentSlide ? "active" : ""}`}
                        onClick={() => setCurrentSlide(i)}
                    ></button>
                ))}
            </div>
        </div>
    );
}